<template>
  <div class="search-page">
    <div :class="['search-container', showType]">
      <!-- global -->
      <div v-if="showType !== 'chat'" class="global-search">
        <!-- <div class="search-title">Global Search</div> -->
        <GlobalSearch ref="globalSearchRef" :input-value="inputValueToSub" />
      </div>
    </div>

    <div class="search-input-container">
      <div v-if="showType === 'all'" class="search-checkbox">
        <n-checkbox
          :checked="checked.globalSearch"
          label="Global Search"
          @update:checked="handleCheckedChange('globalSearch')"
        />

        <n-checkbox
          :checked="checked.chatSearch"
          label="EDM Chat(The content is generated by AI, please carefully identify)"
          @update:checked="handleCheckedChange('chatSearch')"
        />
      </div>

      <n-input v-model:value="inputValue" class="search-input" size="large" round placeholder="" @keyup.enter="search">
        <template #suffix>
          <div class="send-icon" @click="search">
            <em />
          </div>
        </template>
      </n-input>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import GlobalSearch from './GlobalSearch.vue';

const globalSearchRef = ref(null);
const inputValue = ref('');
const inputValueToSub = ref('');
const checked = ref<any>({
  globalSearch: true,
  chatSearch: true,
});

const showType = ref('global'); // all global chat

const generateLoading = ref(false);
const route = useRoute();
const handleCheckedChange = (type: string) => {
  // const { [type], ...other } = checked.value || {}
  const { globalSearch, chatSearch } = checked.value || {};
  // 当只有一个选中，想取消这个选中的
  if (checked.value[type] && !(globalSearch && chatSearch)) {
    window.$message.warning('Please select at least one');
  } else {
    checked.value[type] = !checked.value[type];
  }
};

const search = async () => {
  if (generateLoading.value) {
    window.$message.warning('Please watting, the message is generating right now');
    return;
  }
  if (checked.value.globalSearch) {
    inputValueToSub.value = inputValue.value;
    await nextTick();
    globalSearchRef.value.searchHanlder();
  }

  // inputValue.value = '';
};

onMounted(async () => {
  // window.addEventListener('keyup')
  // 以后暂时不会有all和chat了
  // showType.value = route.query?.type || 'all';

  if (showType.value === 'global') {
    checked.value.chatSearch = false;
  } else if (showType.value === 'chat') {
    checked.value.globalSearch = false;
  }

  if (route.query?.searchValue) {
    inputValue.value = route.query?.searchValue;
    await nextTick();
    search();
  }
});
</script>

<style lang="scss" scoped>
.search-page {
  min-height: calc(100vh - 58px);
  max-height: calc(100vh - 58px);
  background-image: url(/src/assets/edm_bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  overflow: hidden;
  // column-gap: 40px;

  // padding: 32px 284px;
  padding: 32px 15%;
  .search-container {
    display: flex;
    column-gap: 24px;
    height: calc(100vh - 200px);
    min-height: 60vh;
    overflow-y: hidden;
    > div {
      border: 2px solid rgba(231, 237, 253, 1);
      border-radius: 20px;
      // border-image: linear-gradient(rgba(255, 255, 255, 1), rgba(231, 237, 253, 1)) 2 2 2;
      padding: 32px 0 0;

      > * {
        margin: 0 32px;
      }
      .search-title {
        font-size: 24px;
        font-weight: 700;
      }

      .search-subtitle {
        color: #999;
      }

      .chat-prompt {
        padding: 0 32px;
        margin: 20px 0 0 0;
        > div {
          padding: 8px 12px;
          color: #666666;
          font-size: 14px;
          font-weight: 400;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          margin-bottom: 8px;
          cursor: pointer;
          &:hover {
            border-color: #572df3;
            color: #572df3;
          }
        }
      }

      .search-title-tag {
        vertical-align: 10px;
      }
    }
    .global-search {
      height: 100%;
      width: 100%;
      background-image: linear-gradient(rgba(247, 248, 253, 1), rgba(231, 237, 253, 1)); /* 默认方向自下向上 */
    }

    &.global {
      justify-content: center;
      .global-search {
        width: 100%;
      }
    }

    &.chat {
      justify-content: center;
      .llm {
        width: 100%;
      }
    }
  }

  .search-input-container {
    // margin-top: 42px;

    .search-input {
      margin-top: 16px;
    }
  }
}
</style>

<style lang="scss">
.search-page {
  .search-input-container {
    .search-input {
      .send-icon {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        background: rgba(87, 45, 243, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        > em {
          display: inline-block;
          height: 14px;
          width: 14px;
          background: url('@/assets/svg/sendSvg.svg') center no-repeat;
          background-size: 100%;
        }
      }
    }
  }
}
</style>
